module.exports = __webpack_public_path__ + "img/banner02.b9ba676d.jpg";